import _ from 'lodash'

export const cleanCompDefinitionForLogs = componentDefinition =>
    _.pick(componentDefinition, ['id', 'type', 'parent', 'componentType'])
